<template>
	<Alert type="warning">
		<template #icon>
			<IconWarning size="lg" />
		</template>
		<slot />
	</Alert>
</template>

<script>
import Alert from './Alert.vue'
import IconWarning from '../icon/IconWarning.vue'
import AlertMixin from './AlertMixin.js'
export default {
	mixins: [AlertMixin],
	components: {
		Alert,
		IconWarning
	}
}
</script>
